import { render, staticRenderFns } from "./ProductFlowPrice2.vue?vue&type=template&id=a267c1d6"
import script from "./ProductFlowPrice2.vue?vue&type=script&lang=js"
export * from "./ProductFlowPrice2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports